
export const ADMIN_DASHBOARD_HEADER = 'Admin Dashboard'
export const HOME_PAGE_HEADER = 'Accueil'
export const CREATE_NEW_PROJECT_HEADER = 'Création Nouveau Projet'
export const CREATE_NEW_FORM_HEADER = 'Création Nouveau Formulaire'
export const FILES_EXPLORER = 'Explorateur De Fichiers'
